var map = {
	"./Cow.svg": 1357,
	"./Dog.svg": 1358,
	"./Dragon.svg": 1359,
	"./Goat.svg": 1360,
	"./Horse.svg": 1361,
	"./Monkey.svg": 1362,
	"./Ox.svg": 1363,
	"./Pig.svg": 1364,
	"./Rabbit.svg": 1365,
	"./Rat.svg": 1366,
	"./Rooster.svg": 1367,
	"./Snake.svg": 1368,
	"./Tiger.svg": 1369
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 344;


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal ^\.\/.*\.svg$
// module id = 344
// module chunks = 0